import { useAuthStore } from "~/stores/authStore";

export default defineNuxtPlugin(async (nuxtApp) => {
  // Attend le DOM prêt + Pinia initialisée
  const authStore = useAuthStore();
  if (!authStore.isRestored) {
    await authStore.restoreAuth();
  }
});
